<template>
	<core-modal
		:name="campaign.id + '-monster-link-modal'"
		class="omapi-modal monster-link-modal"
		:childRefs="$refs"
	>
		<template v-slot:header>
			<svg-embed />
			Shareable MonsterLink<sup>&trade;</sup>
		</template>

		<modals-content>
			<form @submit.prevent="$modal.hide(campaign.id + '-monster-link-modal')">
				<p>Copy and paste the URL below to use as a direct link to your campaign.</p>

				<common-codebox ref="toFocus">
					{{ monsterLinkPath }}
				</common-codebox>

				<section class="buttons">
					<core-button
						buttonType="submit"
						size="large"
						color="blue"
					>
						Close
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
export default {
	props : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		monsterLinkPath () {
			return this.$urls.app(`c/${this.campaign.id}`)
		},
	},
}
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.monster-link-modal {
	.buttons {
		justify-content: flex-end!important;

		.omapi-button {
			margin-right: 0;
		}
	}
	.omapi-codebox {
		background-color: transparent;
		padding: 0 0 25px 0;

		.omapi-has-tooltip {
			display: block;
			width: 100%;
		}
		&__copy {
			display: flex;
			width: 100%;
			span {
				background-color: $color_white-button-background;
			}
		}
		&__code {
			flex: 1;
		}

	}
}
</style>
